const componentsType = {
  INICIO: {
    id: "INICIO",
    icon: "fa-caret-right",
    title: "Início da conversa",
    secondaryColor: "#333333",
    primaryColor: "#888888",
  },
  TIMEOUT: {
    id: "TIMEOUT",
    icon: "fa-hourglass-end",
    title: "Timeout",
    primaryColor: "#CDCDCD",
    secondaryColor: "#424242",
  },
  IMPROPRIEDADES: {
    id: "IMPROPRIEDADES",
    icon: "fa-angry",
    title: "Impropriedades",
    primaryColor: "#F2D7DD",
    secondaryColor: "#EC244C",
  },
  AVALIACAO: {
    id: "AVALIACAO",
    icon: "fa-thumbs-up",
    title: "Avaliação",
    primaryColor: "#BBDBCF",
    secondaryColor: "#008550",
  },
  REPETICAO: {
    id: "REPETICAO",
    icon: "fa-redo-alt",
    title: "Repetição",
    primaryColor: "#F5D795",
    secondaryColor: "#E08212",
  },
  WATSON: {
    id: "WATSON",
    icon: "fa-comment-dots",
    title: "Watson Assistant",
    primaryColor: "#BF9BC9",
    secondaryColor: "#63007F",
  },
  WATSON_ROOT: {
    id: "WATSON_ROOT",
    icon: "fa-comment-dots",
    title: "Watson Assistant",
    root: true,
    primaryColor: "#BF9BC9",
    secondaryColor: "#63007F",
  },
  WATSON_DIALOG: {
    id: "WATSON_DIALOG",
    icon: "fa-map-signs",
    title: "Diálogo",
    primaryColor: "#F2CFDE",
    secondaryColor: "#C72487",
  },
  WATSON_DIALOG_FOLDER: {
    id: "WATSON_DIALOG_FOLDER",
    icon: " fa-folder",
    title: "Pasta",
    primaryColor: "#bbbc7e",
    secondaryColor: "#666618",
  },
  WATSON_DIALOG_IN_FOLDER: {
    id: "WATSON_DIALOG_IN_FOLDER",
    icon: "fa-map-signs",
    title: "Diálogo",
    primaryColor: "#F2CFDE",
    secondaryColor: "#C72487",
  },
  WATSON_DIALOG_FOLDER_IN_FOLDER: {
    id: "WATSON_DIALOG_FOLDER_IN_FOLDER",
    icon: "fa-folder",
    title: "Pasta",
    primaryColor: "#bbbc7e",
    secondaryColor: "#666618",
  },
  RIVESCRIPT: {
    id: "RIVESCRIPT",
    icon: "fa-code",
    title: "Rivescript",
    primaryColor: "#E8C3DA",
    secondaryColor: "#C72487",
  },
  RESPOSTA_AUTOMATICA: {
    id: "RESPOSTA_AUTOMATICA",
    icon: "fa-reply",
    title: "Resposta Automática",
    primaryColor: "#C7E2FA",
    secondaryColor: "#1351B4",
  },
  PERGUNTAS_E_RESPOSTAS: {
    id: "PERGUNTAS_E_RESPOSTAS",
    icon: "fa-question",
    title: "Perguntas e Respostas",
    primaryColor: "#d6efa7",
    secondaryColor: "#606d68",
  },
  HIERARCHICAL: {
    id: "HIERARCHICAL",
    icon: "fa-comments-dots",
    title: "Orquestrador Hierárquico",
    primaryColor: "#44bcd8",
    secondaryColor: "#1351B4",
  },  
  MS_GPT: {
    id: "MS-GPT",
    icon: "fa-comments-dots",
    title: "GPT",
    primaryColor: "#44bcd8",
    secondaryColor: "#1351B4",
  },
  ASSUNTO_DESCONHECIDO: {
    id: "ASSUNTO_DESCONHECIDO",
    icon: "fa-comment-slash",
    title: "Assunto Desconhecido",
    primaryColor: "#d9d9d9",
    secondaryColor: "#333333",
    fixedLastPosition: true,
  },
};

/** Procura o componentsType com o `att` igual `value`
 *
 * @param {*} att
 * @param {*} value
 */
export const findComponentBy = (att, value) => {
  for (const component in componentsType) {
    if (componentsType[component][att] === value) {
      return componentsType[component];
    }
  }
  return null;
};

export default componentsType;
